(() => {
  function init() {
    const root = document.getElementById('HeirvaleSizeFinder');
    if (!root) return;
    const trigger = root.querySelector('.hv-size-finder__trigger');
    const dialog = root.querySelector('dialog');
    const close = root.querySelector('.hv-size-finder__close');
    if (!trigger || !dialog || !close) return;

    const field = [...document.querySelectorAll('variant-selects .product-form__input')]
      .find(el => [...el.querySelectorAll('input,select')].some(input => /(?:^|\[)size(?:\]|$)/i.test(input.name || '')));
    const label = field?.querySelector('.product-form__label-container');
    if (!label) return;
    label.querySelectorAll('modal-opener.sizing-chart').forEach(opener => { opener.hidden = true; opener.style.display = 'none'; });
    label.appendChild(trigger);
    trigger.hidden = false;

    trigger.addEventListener('click', () => {
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      trigger.setAttribute('aria-expanded', 'true');
    });
    function dismiss() {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
    }
    close.addEventListener('click', dismiss);
    dialog.addEventListener('cancel', event => { event.preventDefault(); dismiss(); });
    dialog.addEventListener('click', event => { if (event.target === dialog) dismiss(); });
    dialog.querySelectorAll('[data-unit]').forEach(button => button.addEventListener('click', () => {
      const unit = button.dataset.unit;
      dialog.querySelectorAll('[data-unit]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      dialog.querySelectorAll('[data-cm][data-in]').forEach(cell => { cell.textContent = cell.dataset[unit]; });
    }));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
